import { client } from './api';
import type {
  CahpsExportListItem,
  CahpsExportListResponse,
  CahpsPreview,
} from './api/types.gen';
import { downloadResponseAsFile } from '../utils/downloadFile';

export type {
  CahpsBranchSummary,
  CahpsExportListItem,
  CahpsGenerateSummary,
  CahpsPreview,
  CahpsProviderSummary,
} from './api/types.gen';

export async function listCahpsExports(): Promise<CahpsExportListItem[]> {
  const response = await client.get<
    { 200: CahpsExportListResponse },
    unknown,
    true
  >({
    responseType: 'json',
    throwOnError: true,
    url: '/cahps-exports',
  });
  return response.data.exports;
}

export async function previewCahpsExport(
  sampleMonth: number,
  sampleYear: number
): Promise<CahpsPreview> {
  const response = await client.get<{ 200: CahpsPreview }, unknown, true>({
    query: { sample_month: sampleMonth, sample_year: sampleYear },
    responseType: 'json',
    throwOnError: true,
    url: '/cahps-exports/preview',
  });
  return response.data;
}

export async function generateCahpsExport(
  sampleMonth: number,
  sampleYear: number
): Promise<CahpsExportListItem> {
  const response = await client.post<
    { 200: CahpsExportListItem },
    unknown,
    true
  >({
    query: { sample_month: sampleMonth, sample_year: sampleYear },
    responseType: 'json',
    throwOnError: true,
    url: '/cahps-exports/generate',
  });
  return response.data;
}

export async function downloadCahpsExport(
  exportId: string,
  fallbackFilename: string
): Promise<void> {
  const response = await client.get<Blob, unknown, true>({
    path: { export_id: exportId },
    responseType: 'blob',
    throwOnError: true,
    url: '/cahps-exports/{export_id}/download',
  });
  downloadResponseAsFile(response, fallbackFilename);
}
